document.addEventListener('DOMContentLoaded', function () {
  initReveals();
  initGaleriaProducto();
  initVariantes();
  initPasosProgreso();
});

function initReveals() {
  var els = document.querySelectorAll('.mt-reveal');
  if (!els.length) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    els.forEach(function (el) { el.classList.add('mt-visible'); });
    return;
  }
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('mt-visible');
        io.unobserve(entry.target);
      }
    });
  }, { threshold: 0.15, rootMargin: '0px 0px -8% 0px' });
  els.forEach(function (el, i) {
    el.style.setProperty('--mt-i', i % 6);
    io.observe(el);
  });
}

function initGaleriaProducto() {
  var wrap = document.querySelector('[data-mt-galeria]');
  if (!wrap) return;
  var principal = wrap.querySelector('[data-mt-galeria-principal]');
  var thumbs = wrap.querySelectorAll('[data-mt-galeria-thumb]');
  if (!principal || !thumbs.length) return;
  thumbs.forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      var full = thumb.dataset.full;
      if (!full) return;
      principal.style.opacity = 0;
      setTimeout(function () {
        principal.src = full;
        principal.style.opacity = 1;
      }, 120);
      thumbs.forEach(function (t) { t.classList.remove('mt-thumb-activo'); });
      thumb.classList.add('mt-thumb-activo');
    });
  });
}

function initVariantes() {
  var form = document.querySelector('[data-mt-form-producto]');
  if (!form) return;
  var variantesRaw = form.querySelector('[data-mt-variantes-json]');
  if (!variantesRaw) return;
  var variantes;
  try { variantes = JSON.parse(variantesRaw.textContent); } catch (e) { return; }

  var selects = form.querySelectorAll('[data-mt-opcion]');
  var idInput = form.querySelector('input[name="id"]');
  var precioEl = document.querySelector('[data-mt-precio]');
  var precioCompareEl = document.querySelector('[data-mt-precio-compare]');
  var botonEl = form.querySelector('[data-mt-boton-comprar]');
  var textoAgotado = form.dataset.textoAgotado || 'Agotado';
  var textoComprar = form.dataset.textoComprar || 'Añadir al carrito';
  var moneyFormat = form.dataset.moneyFormat || '${{amount}}';

  function moneyFmt(cents) {
    var amount = (cents / 100).toFixed(2);
    return moneyFormat.replace('{{amount}}', amount).replace('{{ amount }}', amount);
  }

  function actualizar() {
    var seleccion = Array.prototype.map.call(selects, function (s) { return s.value; });
    var match = variantes.find(function (v) {
      return v.options.every(function (opt, i) { return opt === seleccion[i]; });
    });
    if (!match) return;
    idInput.value = match.id;
    if (precioEl) precioEl.textContent = moneyFmt(match.price);
    if (precioCompareEl) {
      if (match.compare_at_price && match.compare_at_price > match.price) {
        precioCompareEl.textContent = moneyFmt(match.compare_at_price);
        precioCompareEl.style.display = '';
      } else {
        precioCompareEl.style.display = 'none';
      }
    }
    if (botonEl) {
      botonEl.disabled = !match.available;
      var botonSpan = botonEl.querySelector('span');
      if (botonSpan) botonSpan.textContent = match.available ? textoComprar : textoAgotado;
    }
  }

  selects.forEach(function (s) { s.addEventListener('change', actualizar); });
  actualizar();
}

function initPasosProgreso() {
  var wraps = document.querySelectorAll('[data-mt-pasos]');
  if (!wraps.length) return;
  wraps.forEach(function (wrap) {
    var items = wrap.querySelectorAll('[data-mt-paso]');
    if (!items.length) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) entry.target.classList.add('mt-paso-activo');
      });
    }, { threshold: 0.4 });
    items.forEach(function (item) { io.observe(item); });
  });
}
